import React from 'react';
import LogArea from '../../LogArea';

export default (props) => {
  const { content, ...restProps } = props;
  return <LogArea {...restProps} nowrap monoFont>{content}</LogArea>;
};
